// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"178":"6f792c80","358":"7d4366d6"}[chunkId] + ".js";
};